import { Component, HostListener, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { ButtonType } from '../../../shared/enums/button-type.enums';

@Component({
  selector: 'hdi-to-top-button',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './to-top-button.component.html',
  styleUrls: ['./to-top-button.component.scss'],
})
export class ToTopButtonComponent {
  ButtonType = ButtonType;
  isVisible = true;
  private isScrolling: boolean = false;
  private scrollTimeout?: ReturnType<typeof setTimeout>;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isScrolling) {
      this.isScrolling = true;
      this.onScrollStart();
    }

    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
      this.onScrollStop();
    }, 150);
  }

  onScrollStart() {
    this.isVisible = false;
  }

  onScrollStop() {
    this.isVisible = true;
  }

  scrollToTop() {
    this.document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
